module.exports = __webpack_public_path__ + "img/screen_print.38bc771b.jpg";